import { IonLabel, IonTextarea } from "@ionic/react";
import React from "react";
import { InputFactory } from "../Factories/Input";

export default class Textarea extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      value: this.props.value ? this.props.value : "",
      hasFocus: false,
      hasValue: this.props.value && this.props.value !== "",
      count: this.props.value?.length || 0,
    };
  }

  render() {
    const { className, value, onIonChange, maxLength, placeholder, label, ...fieldProps } = this.props;
    const { hasFocus, hasValue, count } = this.state;

    if (fieldProps.disabled) return <InputFactory {...this.props} type="text" />;
    return (
      <div className="input__container">
        {label && <IonLabel>{placeholder}</IonLabel>}
        <IonTextarea
          value={this.state.value}
          className={`${className} ${hasFocus && "has-focus"} ${hasValue && "has-value"} ${count > maxLength && "has-error"}`}
          rows={!this.props.disabled ? 4 : 1}
          autoGrow={true}
          autocapitalize="sentences"
          onIonFocus={this.handleFocus}
          onIonBlur={this.handleBlur}
          onIonChange={this.handleChange}
          placeholder={placeholder}
          {...fieldProps}
        />
        {this.props.maxLength && (
          <span>
            {count} / {maxLength}
          </span>
        )}
      </div>
    );
  }

  handleFocus = () => {
    this.setState({ hasFocus: true });
  };

  handleBlur = () => {
    this.setState({ hasFocus: false });
  };

  handleChange = (e: any) => {
    this.setState({
      value: e.detail.value,
      hasValue: e.detail.value !== "",
      count: e.target.value.length,
    });

    const ionEvent = new CustomEvent("ionChange", {
      detail: {
        name: this.props.name,
        value: e.detail.value,
      },
    });
    this.props.onIonChange?.(ionEvent);
  };
}
